// src/pages/SuccessPage.tsx
import React from 'react';

const SuccessPage: React.FC = () => {
  return (
    <div>
      <h1>Integration Unsuccessful</h1>
      <p>Your Outlook account has not been connected.</p>
    </div>
  );
};

export default SuccessPage;
